import { useEffect, useMemo } from 'react';
import { TargetElementObserver } from 'target-element-observer';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { NAV_ONBOARDING_TOURS_COMPONENT } from 'navigation-components/config';
import { useAppSelector } from '../../../hooks/redux';
import { selectShouldShowNav } from '../../../overlayDisplayConfig/selectors';
import { isSeleniumRunning } from '../../../utils/testEnv';
import { isInOnboardingSession, isOnboardingTourCurrentlyActive, shouldRenderOnboardingTour } from '../../../deferred/onboarding-tours/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const NavOnboardingTourSupport = () => {
  const {
    toggle
  } = useToggleComponent(NAV_ONBOARDING_TOURS_COMPONENT);
  const shouldShowNav = useAppSelector(selectShouldShowNav);
  const shouldShowTour = useMemo(() => Boolean(
  // Makes sure the nav is visible
  shouldShowNav && !isSeleniumRunning() &&
  // Makes sure there is no regular onboarding tour
  // https://product.hubteam.com/docs/growth-onboarding/engineering-docs/onboarding-tours/getting-started.html
  !isInOnboardingSession() && !isOnboardingTourCurrentlyActive() && !shouldRenderOnboardingTour()), [shouldShowNav]);
  useEffect(() => {
    const open = () => toggle(true);
    const close = () => toggle(false);
    if (shouldShowTour) {
      open();
    } else {
      close();
    }
  }, [shouldShowTour, toggle]);
  if (!shouldShowTour) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(TargetElementObserver, {})
  });
};